import { AxiosError } from 'axios'
import { ENDPOINTS } from 'constants/endpoints'
import apiInstance from 'services/api/instance'

import { handleErrorMessage } from '../errors'

export const getAll = async (): Promise<IpAllowedApiResponse[]> => {
  try {
    const getAllResponse = await apiInstance.get<IpAllowedApiResponse[]>(
      ENDPOINTS.IPS_ALLOWED.GET_ALL,
    )

    return getAllResponse.data
  } catch (getAllError) {
    const axiosError = getAllError as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const get = async (id: string): Promise<IpAllowedApiResponse> => {
  try {
    const getResponse = await apiInstance.get<IpAllowedApiResponse>(
      ENDPOINTS.IPS_ALLOWED.GET(id),
    )

    return getResponse.data
  } catch (getError) {
    const axiosError = getError as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const create = async (
  ipAllowed: IpAllowedApiRequest,
): Promise<IpAllowedApiResponse> => {
  try {
    const creationResponse = await apiInstance.post<IpAllowedApiResponse>(
      ENDPOINTS.IPS_ALLOWED.CREATE,
      ipAllowed,
    )

    return creationResponse.data
  } catch (creationError) {
    const axiosError = creationError as AxiosError

    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const update = async ({
  id,
  ipAllowed,
}: {
  ipAllowed: IpAllowedApiRequest
  id: string
}): Promise<IpAllowedApiResponse> => {
  try {
    const updateResponse = await apiInstance.put<IpAllowedApiResponse>(
      ENDPOINTS.IPS_ALLOWED.UPDATE(id),
      ipAllowed,
    )

    return updateResponse.data
  } catch (updateError) {
    const axiosError = updateError as AxiosError

    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const remove = async (id: string) => {
  try {
    const deleteResponse = await apiInstance.delete(
      ENDPOINTS.IPS_ALLOWED.DELETE(id),
    )

    return deleteResponse.data
  } catch (deleteError) {
    const axiosError = deleteError as AxiosError

    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}
